const translations = {
  COMMENT: {
    withParent: "replied to your comment",
    withoutParent: "commented on your post"
  },
  REACTION: {
    withParent: "reacted to your comment",
    withoutParent: "reacted to your post"
  },
  sender: "and {count, plural, one {# other} other {# others}}"
};

export default translations;
